module.exports = __webpack_public_path__ + "static/media/carret-down.0778b0cc.svg";